import { dsClass } from '../../common/constants/dsClasses.js';
import { DeviceSelectionCategoryCoCo, DeviceSelectionProductTypeCoCo } from '../../common/enums.js';
import { noDevicesMsg, selectedDevicesInDeviceSelectionMsg, t } from '../../common/i18n/index.js';
import { EMPTY_VALUE } from '../../common/utils/deviceListUtilsCoCo.js';
import { formatDeviceSelectionCount } from '../../common/utils/deviceSelectionCategoryUtilsCoCo.js';
import {
  getDeviceSelectionItemsByCategory,
  toDeviceSelectionProductType,
} from '../../common/utils/deviceSelectionListUtilsCoCo.js';
import { formatMonthlyPriceCoCo, formatOneTimePriceCoCo } from '../../common/utils/priceUtilsCoCo.js';
import type { DeviceVariantGroupsByTypeCoCo } from '../../common/utils/deviceSelectionDeviceUtilsCoCo.js';
import type { EmployeeProductSelectionResponse } from '../../generated/api/employeeProductSelectionResponse.js';

interface DeviceSelectionDevicesCoCoProps {
  deviceSelection: EmployeeProductSelectionResponse;
  deviceVariantGroups: DeviceVariantGroupsByTypeCoCo;
}

export const DeviceSelectionDevicesCoCo = ({
  deviceSelection,
  deviceVariantGroups,
}: DeviceSelectionDevicesCoCoProps) => {
  const categoryItems = getDeviceSelectionItemsByCategory(deviceSelection, deviceVariantGroups);

  return (
    <section className="of-device-selection-details-coco__devices">
      <h3 className={dsClass.H3}>{t.MDFW(selectedDevicesInDeviceSelectionMsg)}</h3>
      {categoryItems.length === 0 && <p>{t.CD0S(noDevicesMsg)}</p>}
      {categoryItems.map(({ categoryConfig, items }) => (
        <section key={categoryConfig.category} className="of-device-selection-details-coco__category">
          <h4>{formatDeviceSelectionCount(categoryConfig.label(), items.length)}</h4>
          <ul>
            {items.map(item => {
              let formattedPrice = EMPTY_VALUE;
              if (item.price !== undefined) {
                const isOneTimePrice =
                  toDeviceSelectionProductType(deviceSelection.productType) ===
                    DeviceSelectionProductTypeCoCo.PURCHASED ||
                  categoryConfig.category === DeviceSelectionCategoryCoCo.ACCESSORIES_AND_OTHER_DEVICES;
                formattedPrice = isOneTimePrice
                  ? formatOneTimePriceCoCo(item.price)
                  : formatMonthlyPriceCoCo(item.price);
              }
              return (
                <li key={item.uuid}>
                  <span>{item.variantGroupName}</span>
                  <span className="of-device-selection-details-coco__device-price">{formattedPrice}</span>
                </li>
              );
            })}
          </ul>
        </section>
      ))}
    </section>
  );
};
